'use client';

import React from 'react';
import { Box, BoxProps } from '@unity/cloud-ui';
import { useTheme } from '@unity/cloud-ui/styles';
import CodeWrapper from './code-wrapper';

export interface CodeProps {
  children: string;
  title?: string;
  className?: string;
  sx?: BoxProps['sx'];
}

export const Code = (props: CodeProps) => {
  const { children, title, className = '', sx } = props;
  const language = className.split('-').pop() || '';
  const { vars } = useTheme();

  const isInline = !language;

  if (isInline) {
    return (
      <Box
        display="inline"
        sx={{
          backgroundColor: vars.palette.action.hover,
          border: `0.05rem solid ${vars.palette.action.outlinedBorder}`,
          borderRadius: '.375rem',
          px: '0.25em',
          lineHeight: '1.5rem',
          paddingBottom: '0 !important',
          '& > pre': { display: 'inline', whiteSpace: 'pre-wrap' },
          ...sx,
        }}
      >
        <pre>
          <code>{children}</code>
        </pre>
      </Box>
    );
  }

  const codeBlock = {
    title,
    language,
    code: children,
  };

  return <CodeWrapper codeBlocks={[codeBlock]} />;
};

export default Code;
